import React, { useEffect, useState } from "react";
import { LINKS, CHECKOUT_RADIOGRAFIA_49 } from "@/lib/content";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "py-3 backdrop-blur-xl bg-[#10202e]/75 border-b border-[#c5a059]/15"
          : "py-5 bg-transparent"
      }`}
    >
      <div className="et-container flex items-center justify-between">
        <a
          href={LINKS.home}
          data-testid="navbar-logo"
          className="flex items-center gap-2.5 group"
        >
          {/* Monogram */}
          <span
            className="grid place-items-center w-9 h-9 rounded-full text-[#10202e] font-bold text-sm tracking-tight"
            style={{
              background:
                "linear-gradient(135deg, #c5a059 0%, #e3c98c 50%, #c5a059 100%)",
              boxShadow: "0 4px 14px -4px rgba(197,160,89,0.6)",
            }}
          >
            ET
          </span>
          <span className="text-[#f5f2ea] font-semibold tracking-tight text-base hidden sm:block">
            Enrique Torres
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#f5f2ea]/75">
          <a
            href="#problema"
            data-testid="nav-problema"
            className="hover:text-[#c5a059] transition-colors"
          >
            Problema
          </a>
          <a
            href="#filosofia"
            data-testid="nav-filosofia"
            className="hover:text-[#c5a059] transition-colors"
          >
            Filosofía
          </a>
          <a
            href="#metodo"
            data-testid="nav-metodo"
            className="hover:text-[#c5a059] transition-colors"
          >
            Método
          </a>
          <a
            href="#oferta"
            data-testid="nav-oferta"
            className="hover:text-[#c5a059] transition-colors"
          >
            Qué incluye
          </a>
        </nav>

        <a
          href={CHECKOUT_RADIOGRAFIA_49}
          target={CHECKOUT_RADIOGRAFIA_49.startsWith("http") ? "_top" : undefined}
          data-testid="navbar-cta"
          className="et-btn-primary !py-2.5 !px-4 text-sm"
        >
          Hacer mi Radiografía por 49 €
        </a>
      </div>
    </header>
  );
};

export default Navbar;
